export default __webpack_public_path__ + "static/media/published.7517a1d9.svg";